import { useStore } from '@/store';
import { ensureChatwootUserIdentified, isChatwootUserSynchronized } from '@/services/utils/chatwoot';

export const useIntercom = () => {
  const store = useStore();
  const getFeatureFlags = () => store.user.featureFlags || {};

  const openLiveSupport = () => {
    const featureFlags = getFeatureFlags();

    if (featureFlags.chatwoot?.enabled) {
      const user = store.user;
      const openWidget = () => (window as any).$chatwoot.toggle('open');

      if (!user.id) {
        return;
      }

      if ((window as any).$chatwoot?.toggle && isChatwootUserSynchronized(user)) {
        console.info('[chatwoot-sync] open-widget-fast-path', { userId: user.id });
        openWidget();
        return;
      }

      console.info('[chatwoot-sync] open-widget-after-sync', { userId: user.id });
      ensureChatwootUserIdentified(user).then(openWidget);
    } else {
      (window as any).$intercom?.show();
      (window as any).$intercom?.boot({ hide_default_launcher: false });
      store.setLiveChatOpen(true);
    }
  };

  const closeLiveSupport = () => {
    const featureFlags = getFeatureFlags();

    if (featureFlags.chatwoot?.enabled) {
      (window as any).$chatwoot?.toggle('close');
    } else {
      (window as any).$intercom?.hide();
      (window as any).$intercom?.boot({ hide_default_launcher: true });
      store.setLiveChatOpen(false);
    }
  };

  return { openLiveSupport, closeLiveSupport };
};
